import axios from "../customize_axios";
export const processAddToCart = async (token, bookID, quantity) => {
  try {
    const response = await axios.post(
      "/api/cart",
      { bookID, quantity },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    // Kiểm tra và ném lỗi chi tiết hơn
    const errorMessage =
      error.response?.data?.message || "Đã xảy ra lỗi khi thêm vào giỏ hàng.";
    throw new Error(errorMessage); // Ném lỗi để xử lý ở cấp cao hơn
  }
};


export const getDetailedCart = async (token, page = 0) => {
  try {
    const response = await axios.get(`/api/cart?page=${page}`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    // console.log(response)
    return response.data;
  } catch (error) {
    console.error("Error fetching cart details:", error);
    return null;
  }
};

export const removeItems = async (token, bookIDs) => {
  console.log("laptopis", bookIDs)
  try {
    const response = await axios.delete("/api/cart", 
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        data: { bookIDs: Array.isArray(bookIDs) ? bookIDs : [bookIDs] } 
      }
    );
    console.log("Remove items response from service:", response);
    return response;
  } catch (error) { 
    if (error.response) {
      console.error("Error removing items from cart, response status:", error.response.status);
      console.error("Error response data:", error.response.data);
      console.error("Error response headers:", error.response.headers);
    } else {
      console.error("Error removing items from cart:", error.message);
    }
    return null;
  }
};

export const updateQuantity = async (token, bookID, quantity) => {
  try {
    const response = await axios.put("/api/cart",
      { bookID, quantity},
      {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
     
    });
    return response;
  } catch (error) {
    console.error("Error updating quantity:", error);
    throw error;
  }
};